import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {makeAutoObservable} from "mobx";
import {Bindings} from "data/constants/bindings";
import type {IStaticStore} from "data/stores/static/static.store";
import {IStaticItem} from "data/providers/json/json.provider";
import type {IUser, IUserStore} from "data/stores/user/user.store";

export interface IHelpController extends ViewController {
	get isLoading(): boolean;
	get faqItems(): IStaticItem[];
	get guidelinesItems(): IStaticItem[];
	get termsItems(): IStaticItem[];
	get prizeItems(): IStaticItem[];
	get user(): IUser | undefined;
}

@injectable()
export class HelpController implements IHelpController {
	constructor(
		@inject(Bindings.StaticStore) private _staticStore: IStaticStore,
		@inject(Bindings.UserStore) private _userStore: IUserStore
	) {
		makeAutoObservable(this);
	}

	get isLoading() {
		return this._staticStore.getIsLoading;
	}

	get faqItems() {
		return this._staticStore.listHelpPages.faq || [];
	}

	get guidelinesItems() {
		return this._staticStore.listHelpPages.how_to_play || [];
	}

	get termsItems() {
		return this._staticStore.listHelpPages.terms || [];
	}

	get prizeItems() {
		return this._staticStore.listHelpPages.prizes || [];
	}

	async init() {
		await this._staticStore.fetchHelpPages();
	}

	get user() {
		return this._userStore.user;
	}

	dispose() {
		return;
	}
}
